module.exports = __webpack_public_path__ + "img/coin.1c7ef929.svg";